import { makeStyles } from "@material-ui/core"
import newColors from "@/styles/newColors"

const useStyles = makeStyles(({
	item: {
		maxWidth: 420
	},
	text: {
		fontSize: "28px",
		color: newColors.grey[800],
		fontWeight: 500
	},
	description: {
		fontSize: "16px",
		color: newColors.grey[400],
		textAlign: "center"
	},
	button: {
		width: "100%"
	}
}))

export default useStyles
